export default "/img/BD.e7b4a00a33eab33750c1150fe7cc8021.png";